// Lib
import React, { useEffect } from 'react';

// Utils
import boardSearchPopupStayActivePredicate from './boardSearchPopupStayActivePredicate';

// Components
import Icon from '../../../../components/icons/Icon';
import TooltipSource from '../../../../components/tooltips/TooltipSource';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';
import PopupTrigger from '../../../../components/popupPanel/PopupTrigger';
import LoadableBoardSearchPanel from './LoadableBoardSearchPanel';

// Hooks
import useBoardSearchState from './state/useBoardSearchState';

// Constants
import { PopupIds, PopupSections } from '../../../../components/popupPanel/popupConstants';

// Types
import { ImMNCurrentUser } from '../../../../user/currentUserSelector';

// Styles
import '../HeaderUtil.scss';

const SearchUtil = ({
    currentUser,
    currentBoardId,
    tooltipEnabled,
}: {
    currentBoardId: string;
    currentUser: ImMNCurrentUser;
    tooltipEnabled: boolean;
}): React.ReactElement => {
    const searchState = useBoardSearchState();

    useEffect(() => {
        LoadableBoardSearchPanel.preload();
    }, []);

    return (
        <div className="HeaderUtil BoardSearchUtil">
            <TooltipSource
                tooltipText="Search"
                shortcut={['command', 'f']}
                distance={0}
                enabled={tooltipEnabled}
                delay={700}
                triggerOnMouseEnter
            >
                <PopupTrigger
                    popupId={PopupIds.SEARCH}
                    className="button-search header-util-button"
                    closeSection={PopupSections.HEADER}
                    stayActivePredicate={boardSearchPopupStayActivePredicate}
                >
                    {() => (
                        <div className="header-util-button-content">
                            <Icon name="nav-search" />
                        </div>
                    )}
                </PopupTrigger>
            </TooltipSource>
            <PopupPanel popupId={PopupIds.SEARCH} className="BoardSearchPopup">
                <LoadableBoardSearchPanel searchState={searchState} />
            </PopupPanel>
        </div>
    );
};

export default SearchUtil;
